// @flow

import * as React from 'react';
import {useRef, useEffect} from 'react';
import classNames from 'classnames';

import {useFile} from 'docs/data/integration-builder';

import '../../CodeBlock/CodeBlock.scss';
import './File.scss';

import type {Condition} from 'docs/data/integration-builder';

type FileProps = {|
  language: string,
  filename: string,
  downloadOnly: boolean,
  children: React.Element<any>,
  when: Condition,
|};

export const File = ({language, filename, children}: FileProps) => {
  const ref = useRef(null);
  const {setContentRef, activeFile} = useFile();

  const setRef = useRef(setContentRef);
  useEffect(() => {
    // Use a ref to this function so we don't get caught rerendering
    setRef.current(filename, ref);
  }, [filename]);

  return (
    <code
      ref={ref}
      className={classNames(
        'CodeBlock',
        !(activeFile === filename) && 'CodeBlock--hidden',
      )}
    >
      {children}
    </code>
  );
};
